import { ActionedRole, CreditEventType } from '~/types'

export const actionedRoles: Record<ActionedRole, string> = {
  [ActionedRole.ASSURO_CLIENT_USER]: 'Client',
  [ActionedRole.ASSURO_RELATIONSHIP_MANAGER]: 'Admin',
  [ActionedRole.ASSURO_SYSTEM]: 'System',
}

export const actionedRole = (role: ActionedRole) => {
  return actionedRoles[role]
}

export const creditAmount = (event: CreditEventType, amount: string) => {
  const negative = event === CreditEventType.USED || event === CreditEventType.VOIDED

  return negative ? `-${amount}` : amount
}
